module.exports = "/_next/static/images/d7699a24c9356c823e27dc61317a4077-fecha.gif";